module.exports = "pegasus_template/assets/presentation-card.png";